"use client";

import { FormattedMessage } from "react-intl";

function NA() {
  return <FormattedMessage id='n.a.' defaultMessage={'N/A'} />
}

export default NA;